import React from "react";
import { Link } from "react-scroll";
// SCSS
import "./navbar.scss";
// Assets
import CloseIcons from "../../assets/navbar/mobile-close.svg";
import Logo from "../../assets/navbar/logo-small.png";

// Translation Data
const translations = {
  en: {
    about: "ABOUT",
    services: "SERVICES",
    clients: "CLIENTS",
    contact: "CONTACT",
  },
  ar: {
    about: "من نحن",
    services: "خدماتنا",
    clients: "عملائنا",
    contact: "اتصل بنا",
  },
};

const MobileNav = (props) => {
  const { language, toggleLanguage, closeMobileMenu, isOpen } = props; // Use language from props

  const isArabic = language === "ar"; // Check if language is Arabic

  return (
    <div className={`mobile__navbar ${isOpen ? "mobile__open" : ""}`}>
      <div className="mobile__navbar-close" onClick={closeMobileMenu}>
        <img src={CloseIcons} alt="close" />
      </div>
      <div className="mobile__navbar-logo flex-center">
        <Link
          to="hero"
          spy={true}
          smooth={true}
          duration={500}
          onClick={closeMobileMenu}
        >
          <img height={100} width={100} src={Logo} alt="logo" />
        </Link>
      </div>
      <div className="mobile__navbar-menu">
        <ul className={isArabic ? "rtl" : ""}>
          <li className="flex-center">
            <Link
              activeClass="active-link"
              to="about"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              onClick={closeMobileMenu}
            >
              {translations[language].about}
            </Link>
          </li>
          <li className="flex-center">
            <Link
              activeClass="active-link"
              to="services"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              onClick={closeMobileMenu}
            >
              {translations[language].services}
            </Link>
          </li>
          <li className="flex-center">
            <Link
              activeClass="active-link"
              to="blog"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              onClick={closeMobileMenu}
            >
              {translations[language].clients}
            </Link>
          </li>
          <li className="flex-center">
            <Link
              activeClass="active-link"
              to="contact"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              onClick={closeMobileMenu}
            >
              {translations[language].contact}
            </Link>
          </li>
        </ul>
        <button className="language-toggle" onClick={toggleLanguage}>
          {isArabic ? "English" : "العربية"}
        </button>
      </div>
    </div>
  );
};

export default MobileNav;
